// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2umH4","header":"PatientBlock_header__3Fe5A","label":"PatientBlock_label__1scFq","option":"PatientBlock_option__f4Dgo"};